
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/password-reset",
      function () {
        return require("private-next-pages/account/password-reset/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/password-reset"])
      });
    }
  